export type VertragsbeginnRangeReason =
  | 'school-year-start-in-future'
  | 'current-month'
  | 'following-month'
  | 'school-year';

export interface VertragsbeginnRange {
  minDate: Date;
  maxDate: Date;
  reason: VertragsbeginnRangeReason;
}

function addMonths(date: Date, months: number): Date {
  return new Date(date.getFullYear(), date.getMonth() + months, 1);
}

export function computeVertragsbeginnRange(
  schoolYearStart: Date,
  schoolYearEnd: Date,
  today: Date,
  applicantDeadlineDay: number | null,
  monthSelection: boolean,
  earliestVertragsbeginn?: Date | null
): VertragsbeginnRange {
  let minDate: Date;
  let reason: VertragsbeginnRangeReason;

  if (!monthSelection) {
    minDate = schoolYearStart;
    reason = 'school-year';
  } else if (schoolYearStart > today) {
    minDate = new Date(schoolYearStart.getFullYear(), schoolYearStart.getMonth(), 1);
    reason = 'school-year-start-in-future';
  } else {
    const afterApplicantDeadline = applicantDeadlineDay !== null
      && today.getDate() > applicantDeadlineDay;
    const earliestMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    minDate = afterApplicantDeadline ? addMonths(earliestMonth, 1) : earliestMonth;
    reason = afterApplicantDeadline ? 'following-month' : 'current-month';
  }

  if (earliestVertragsbeginn && minDate < earliestVertragsbeginn) {
    minDate = earliestVertragsbeginn;
  }

  return { minDate, maxDate: schoolYearEnd, reason };
}
